import { Request } from 'api';
import { AxiosResponse } from 'axios';

type ReturnType = Promise<AxiosResponse<void>>;

const removeSharedUser = (id: string, userId: string): ReturnType => {
    return Request.delete(`/workouts/sessions/${id}/users/${userId}`);
};

export default removeSharedUser;
